/* eslint-disable */
import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import {
  TableRow,
  TableCell,
  TableHead,
  TablePagination,
  IconButton,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { typeConversion } from "../../../../shared/methods/sharedMethods";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  head: {
    fontWeight: 600,
    fontSize: "16px",
    whiteSpace: "nowrap",
  },
  borderTop: {
    borderTop: "1px solid rgba(224, 224, 224, 1)",
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const {
    count, page, rowsPerPage, onChangePage,
  } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

export function Header(props) {
  const classes = useStyles1();
  const { templateString, collapsable } = props;
  return (
    <TableHead>
      <TableRow>
        {Object.values(templateString).map((header, idx) => (
          <TableCell align="left" className={classes.head} key={idx}>{header}</TableCell>
        ))}
        {collapsable && <TableCell className={classes.borderTop} />}
      </TableRow>
    </TableHead>
  );
}

export function Row(props) {
  const classes = useStyles1();
  const { templateString, row, collapseable } = props;
  const history = useHistory();
  return (
    <TableRow className={classes.borderTop}>
      {Object.keys(templateString).map((key, idx) => (
        <TableCell key={`${key}_${idx}`} align="left">{typeConversion(key, row[key])}</TableCell>
      ))}
      {collapseable
                    && (
                      <TableCell>
                        <div
                          className="theme-button-container"
                          style={{ color: "#f37c20", width: "48%" }}
                          onClick={() => {
                            history.push("/settlement/operator-settlement/previous-settlement-details", row);
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              history.push("/settlement/operator-settlement/previous-settlement-details", row);
                            }
                          }}
                        >
                          Details
                        </div>
                      </TableCell>
                    )}
    </TableRow>
  );
}

export function Footer(props) {
  const {
    colSpan, count, rowsPerPage, rowsPerPageOptions, page, SelectProps,
  } = props;
  return (
    <div className="pagination-icons">
      <TablePagination
        colSpan={colSpan}
        count={count}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        page={page}
        SelectProps={SelectProps}
        onChangeRowsPerPage={(event) => {
          props.onChangePage("rowsPerPage", +event.target.value);
          props.onChangePage("pageNo", 0);
        }}
        onChangePage={(event, newpage) => props.onChangePage("pageNo", newpage)}
        ActionsComponent={TablePaginationActions}
        className="display-flex flex-end"
        style={{ display: "flex" }}
      />
    </div>
  );
}
